export default "<button class=\"unlock purchase full-width\">\n    Unlock all titles<% if (this.price) { %> for <%- this.price %><% } %>\n</button>";